export default "__VITE_ASSET__DipRAwDU__"